import { functionUrls } from '../../../services/firebaseFunctions';
import { parseHistoricalPeriodsMarkdown } from '../../../utils/historicalPeriodsParser';
import { loginMachine } from '../../../auth/loginMachine';
import type { HistoricalPeriodItem } from '../types/detailsCard.types';

export async function fetchHistoricalPeriodsMarkdown(params: {
  topicName: string;
  userLanguageLabel: string;
  signal: AbortSignal;
}): Promise<HistoricalPeriodItem[]> {
  const { topicName, userLanguageLabel, signal } = params;

  loginMachine.recordUsage('llm');

  const idToken = await loginMachine.getIdToken();
  if (!idToken) {
    const err: any = new Error('AUTH_REQUIRED');
    err.code = 'AUTH_REQUIRED';
    throw err;
  }

  const query = new URLSearchParams({
    location: topicName,
    userLanguageLabel,
  });

  const url = `${functionUrls.getHistoricalPhasesMarkdownList}?${query.toString()}`;
  const resp = await fetch(url, {
    headers: {
      Accept: 'text/markdown',
      Authorization: `Bearer ${idToken}`,
    },
    signal,
  });

  if (resp.status === 401 || resp.status === 403) {
    const err: any = new Error('AUTH_REQUIRED');
    err.code = 'AUTH_REQUIRED';
    throw err;
  }

  if (!resp.ok) {
    throw new Error(`HTTP ${resp.status}`);
  }

  const text = await resp.text();
  return parseHistoricalPeriodsMarkdown(text) as HistoricalPeriodItem[];
}
